/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Directive for handling opening a logged out modal if a user sessions expires.
 */
angular.module('bulbApp.alertsModule')
  .directive('bulbLoggedOutAlert', bulbLoggedOutAlert);

function bulbLoggedOutAlert() {
  return {
    restrict: 'E',
    scope: true,
    controller: 'LoggedOutAlertController as loggedOutCtrl',
  };
}
